import React, {useState, MouseEvent, FC} from 'react';
import Box from '@material-ui/core/Box';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
import {ListProps, ListItemProps, PopoverProps, Popover, withStyles} from '@material-ui/core';

// @ts-ignore
import {Theme} from '@epic-ui/epic';
import PopperInput from '../../common/PopperInput';

import {Option} from '../../../types';

const StyledList = withStyles<string, undefined, ListProps & {component: string}>(theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2)
    }
}))(List);

export const StyledPopover = withStyles((theme: Theme) => ({
    paper: {
        marginTop: theme.spacing(1),
        backgroundColor: theme.palette.background.overlays,
        width: 'inherit'
    }
}))(Popover);

const StyledListItem = withStyles<string, undefined, ListItemProps>(theme => ({
    root: {
        color: theme.palette.text.secondary,

        '&:active': {
            color: theme.palette.text.primary
        },
        '&.Mui-selected': {
            color: theme.palette.text.primary
        }
    }
}))(ListItem);

export interface CategorySelectProps extends Omit<PopoverProps, 'onChange' | 'open'> {
    options: Option[];
    value: Option;
    onChange: (timeScale: Option) => void;
    onClose?: () => void;
}

const CategorySelect: FC<CategorySelectProps> = ({
    onChange,
    options,
    value: activeOption,
    ...props
}: CategorySelectProps) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleOptionClick = (option: Option) => {
        setAnchorEl(null);
        onChange(option);
    };

    const open = Boolean(anchorEl);

    return (
        <>
            <Box width="inherit">
                <PopperInput open={open} value={activeOption.label} onClick={handleClick} />
            </Box>
            <StyledPopover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClick}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center'
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center'
                }}
                {...props}>
                <Box mt={2}>
                    <StyledList component="div">
                        {options.map(option => (
                            <StyledListItem
                                button
                                key={option.label}
                                selected={activeOption.value === option.value}
                                onClick={() => handleOptionClick(option)}>
                                <Typography variant="body1">{option.label}</Typography>
                            </StyledListItem>
                        ))}
                    </StyledList>
                </Box>
            </StyledPopover>
        </>
    );
};

export default CategorySelect;
